import React, {Component} from 'react';
import {deepCopyObject, showAxiosError} from "../../../helper/helper";
import Alert from 'react-s-alert';
import {request} from "../../../helper/APIUtils";
import {Modal} from "react-bootstrap";
import {Col, Row} from "reactstrap";
import SweetAlert from 'react-bootstrap-sweetalert';


class ChangePassword extends Component {

	constructor(props) {
		super(props);
		this.state = {alert: null};
		this.handlePasswordChange = this.handlePasswordChange.bind(this);
	}

	confirmPasswordUpdate() {
		let passwordPayload = deepCopyObject(this.props.passwordPayload);
		if (passwordPayload.currentPassword || this.props.impersonate) {
			if (passwordPayload.newPassword && passwordPayload.newPasswordCopy) {
				const validation = this.props.passwordValidation(passwordPayload.newPassword,"both");
				if(validation.error){
					Alert.error(validation.errorMessage, {
						position: 'top-right',
						effect: 'stackslide',
						timeout: 5000,
						html:false
					});
					return;
				}
				if (passwordPayload.newPassword === passwordPayload.newPasswordCopy) {
					this.handlePasswordChange();
				} else {
					Alert.error('Uyumsuz Şifre', {
						position: 'top-right',
						effect: 'stackslide',
						timeout: 5000,
						html:false
					});
				}
			} else {
				Alert.error('Yeni Şifre Giriniz', {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 5000,
					html:false
				});
			}
		} else {
			Alert.error('Mevcut Şifrenizi Giriniz', {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 5000,
				html:false
			});
		}
	}

	handlePasswordChange() {
		let self = this;
		let data = deepCopyObject(self.props.passwordPayload);
		if (self.props.impersonate) {
			data.impersonate = deepCopyObject(self.props.impersonate);
		}
		let params = {
			url: `/user/updatePassword`,
			data: data,
			method: 'post'
		};
		request(params).then(() => {
			this.setState({
				alert: (
					<SweetAlert success
								title="Şifreniz Başarıyla Güncellendi"
								confirmBtnText="Tamam"
								confirmBtnBsStyle="success"
								onConfirm={()=> {this.setState({alert: null}, () => this.props.closePasswordModal());this.props.logOut()}}>
						Eski şifrenizi, varsa diğer harici yazılımlarda da güncellemeyi unutmayınız.
					</SweetAlert>
				)
			});
		}).catch(function (error) {
				showAxiosError(error);
			});
	}

	showRelatedPassword(target) {
		let nextState = document.getElementById(target).getAttribute('type') === 'password' ? 'text' : 'password';
		document.getElementById(target).setAttribute('type', nextState);
	}

	render() {
		return (
			<div>

				{this.state.alert && this.state.alert}

				<Modal show={this.props.isOpen}
					   animation={false}
					   toggle={() => this.props.closePasswordModal()}
					   modalTransition={{timeout: 700}}
					   dialogClassName="modal-90w"
					   backdropTransition={{timeout: 1300}}
					   aria-labelledby="example-custom-modal-styling-title"
					   backdrop="static">
					<Modal.Header>Şifre Değiştir</Modal.Header>
					<Modal.Body>
						{!this.props.impersonate &&
						<div style={{overflow: 'hidden'}}>
							<Row>
								<Col xs='12' sm='12' md='4' lg='4'>
									<label>Mevcut Şifre</label>
								</Col>

								<Col xs='12' sm='12' md='8' lg='8'>
									<input className="form-control"
										   type="password"
										   name="currentPassword"
										   id="tCurrentPassword"
										   data-vlength="1,255"
										   data-vdata="required"
										   ref="tCurrentPassword"
										   value={this.props.passwordPayload.currentPassword && this.props.passwordPayload.currentPassword}
										   onChange={(e) => this.props.onChangePasswordPayload(e)}/>
								</Col>
							</Row>
							<i className="far fa-eye" onClick={() => this.showRelatedPassword('tCurrentPassword')}
							   style={{float: 'right', position: 'relative', marginRight: '5px', bottom: '24px'}}/>
						</div>}

						<div style={{overflow: 'hidden'}}>
							<Row>
								<Col xs='12' sm='12' md='4' lg='4'>
									<label className='col-form-label'>Yeni Şifre</label>
								</Col>

								<Col xs='12' sm='12' md='8' lg='8'>
									<input className="form-control"
										   type="password"
										   name="newPassword"
										   id="tNewPassword"
										   data-vlength="1,255"
										   data-vdata="required"
										   ref="tNewPassword"
										   value={this.props.passwordPayload.newPassword && this.props.passwordPayload.newPassword}
										   onBlur={(e)=>this.props.onBlurPasswordPayload(e)}
										   onChange={(e) => this.props.onChangePasswordPayload(e)}/>
								</Col>
							</Row>
							<i className="far fa-eye" onClick={() => this.showRelatedPassword('tNewPassword')}
							   style={{float: 'right', position: 'relative', marginRight: '5px', bottom: '24px'}}/>
						</div>

						<div style={{overflow: 'hidden'}}>
							<Row>
								<Col xs='12' sm='12' md='4' lg='4'>
									<label className='col-form-label'>Yeni Şifre(Tekrar)</label>
								</Col>

								<Col xs='12' sm='12' md='8' lg='8'>
									<input className="form-control"
										   type="password"
										   name="newPasswordCopy"
										   id="tNewPasswordCopy"
										   data-vlength="1,255"
										   data-vdata="required"
										   ref="tNewPasswordCopy"
										   value={this.props.passwordPayload.newPasswordCopy && this.props.passwordPayload.newPasswordCopy}
										   onChange={(e) => this.props.onChangePasswordPayload(e)}/>
								</Col>
							</Row>
							<i className="far fa-eye" onClick={() => this.showRelatedPassword('tNewPasswordCopy')}
							   style={{float: 'right', position: 'relative', marginRight: '5px', bottom: '24px'}}/>
						</div>

					</Modal.Body>
					<Modal.Footer>
						<Col xs='6' sm='6' md='6' lg='6' style={{textAlign: 'center'}}>
							<button type="button"
									style={{background: 'rgb(158, 158, 158)', padding: '11px 45px 11px 20px'}}
									className="TekBtn vazgec"
									onClick={() => this.props.closePasswordModal()}>İptal
							</button>
						</Col>

						<Col xs='6' sm='6' md='6' lg='6' style={{textAlign: 'center'}}>
							<button type="button"
									style={{background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)', padding: '11px 45px 11px 20px'}}
									className="TekBtn kaydet"
									onClick={() => this.confirmPasswordUpdate()}>Onayla
							</button>
						</Col>
					</Modal.Footer>
				</Modal>
			</div>
		)
	}
}

export default ChangePassword;